import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { preferencesKeys } from 'shared/lib/preferences';

import { patchUser } from '../requests';
import type { PatchUserRequestType } from '../types';

export const usePatchUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bodyParams: PatchUserRequestType['bodyParams']) =>
      patchUser({
        bodyParams,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.user],
      });
      if (variables.lastBoardId) {
        queryClient.invalidateQueries({
          queryKey: [API_QUERY_KEYS.userBoards],
        });
        // Board switch — preferences are scoped per board, drop the cache
        // of the previous board so the new board's layer is refetched.
        queryClient.invalidateQueries({
          queryKey: preferencesKeys.all(),
        });
      }
    },
  });
};
